import Axios, { AxiosInstance } from 'axios';

/**
 *  The API logic of the tool.
 */
class Api {

    /**
     *
     *  Singleton HTTP client that is used to
     *  communicate with the API.
     *
     *  (i) Requests are proxied to the API (to add auth), so it
     *  should always request `/api` at the current location
     *
     */
    public client: AxiosInstance = Axios.create({
        baseURL: process.env.NODE_ENV === 'development' ? '/api' : '/tool/api',
        responseType: 'json',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });

    /**
     *
     *  Used to fetch the CSRF token that is mandatory for the API proxy.
     *
     *  (i) Stores it in the clients' default common headers after fetching
     *
     */
    public async fetchCSRFToken(): Promise<void> {

        const { data } = await this.client.get<string>('/csrf-token');

        this.client.defaults.headers.common['csrf-token'] = data;

    }

    /**
     *
     *  Used to store the provided company guid in the client's default headers.
     *
     *  @param companyGuid The guid of the company for which the tool is used
     *
     */
    public setCompanyGuid(companyGuid: string): void {

        this.client.defaults.headers.common['Company-Guid'] = companyGuid;

    }

    /**
     *
     *  Used to store the provided company secret in the client's default headers.
     *
     *  @param companySecret The secret of the company for which the tool is used
     *
     */
    public setCompanySecret(companySecret: string): void {

        this.client.defaults.headers.common['Company-Secret'] = companySecret;

    }

}

export default new Api();
